import { type MultipliersResponse, type CategoryData, type Multiplier } from "@/api/multipliers";

export const transformToDefaultValues = (data: MultipliersResponse): MultipliersResponse => {
    const transformedData: MultipliersResponse = {};

    Object.entries(data).forEach(([categoryKey, categoryValue]) => {
        if (categoryKey === "total" && categoryValue && !Array.isArray(categoryValue)) {
            const totalMultiplier = categoryValue as Multiplier;
            transformedData.total = {
                ...totalMultiplier,
                maxPoints: totalMultiplier.defaultMaxPoints,
                weight: totalMultiplier.defaultWeight,
            };
        } else if (Array.isArray(categoryValue)) {
            const transformedCategory = categoryValue.map((group: CategoryData) => {
                const transformedGroup: CategoryData = {
                    max: null,
                    weights: null,
                };

                if (group.max) {
                    transformedGroup.max = {
                        ...group.max,
                        maxPoints: group.max.defaultMaxPoints,
                        weight: group.max.defaultWeight,
                    };
                }

                if (group.weights) {
                    transformedGroup.weights = group.weights.map((weight) => ({
                        ...weight,
                        maxPoints: weight.defaultMaxPoints,
                        weight: weight.defaultWeight,
                    }));
                }

                return transformedGroup;
            });

            // Type assertion for category assignment
            if (categoryKey === "offensive") {
                transformedData.offensive = transformedCategory;
            } else if (categoryKey === "defensive") {
                transformedData.defensive = transformedCategory;
            } else if (categoryKey === "teamplay") {
                transformedData.teamplay = transformedCategory;
            } else if (categoryKey === "effort") {
                transformedData.effort = transformedCategory;
            } else if (categoryKey === "bonus") {
                transformedData.bonus = transformedCategory;
            }
        }
    });

    return transformedData;
};
